<template>
  <div class="main-container bg-grey-lightest">
    <div class="main-content-wrap max-center">
      <div class="main-content-pannel" v-if="consultant">
        <div
          class="option-wrap bg-grey-lightest grey-bg-option no-border"
          style="height: 80px"
        >
          <div class="options">
            <div class="content-title-wrap p-t-0">
              <div class="main-content-title">
                <div class="main-content-title-person">
                  <div class="avatar-container">
                    <div class="avatar">
                      <span
                        v-if="!consultant.photo_url || type !== 'allinfo'"
                        >{{
                          (type !== "allinfo"
                            ? "a"
                            : consultant.name
                            ? consultant.name
                            : consultant.email) | getFirstLetter
                        }}</span
                      >
                      <img v-else :src="consultant.photo_url" alt />
                    </div>
                    <span
                      class="status-pill avatar-ative"
                      :class="{
                        red: !consultant.is_active,
                        green: consultant.is_active,
                      }"
                      :title="consultant.is_active ? 'Active' : 'Inactive'"
                    ></span>
                  </div>
                  <div class="connsultant-resume-info">
                    <div class="connsultant-resume-name">
                      <h3 v-if="type == 'allinfo'" style="margin: 0">
                        {{ consultant.name | getShorterName }}
                      </h3>
                      <h3 v-else style="margin: 0">Anonymous</h3>
                      <i
                        class="material-icons align-middle font-color-lighter"
                        v-if="
                          (consultant.client_confirm ||
                            consultant.reply === 'yes') &&
                          !(
                            consultant.client_confirm &&
                            consultant.reply === 'yes'
                          )
                        "
                        >check</i
                      >
                      <i
                        class="material-icons align-middle font-color-lighter"
                        v-if="
                          consultant.client_confirm &&
                          consultant.reply === 'yes'
                        "
                        >done_all</i
                      >
                      <i
                        class="material-icons align-middle font-color-green"
                        v-if="consultant.verified"
                        >verified</i
                      >
                    </div>
                    <div class="connsultant-resume-location flex">
                      <span class="tech_lvl_tag"
                        ><i class="material-icons align-middle">stream</i
                        >{{ consultant.tech_level }}</span
                      >
                      <i class="material-icons align-middle">location_on</i>
                      {{ consultant.metro }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="main-flex m-t-4l">
          <div class="main-flex-1 flex-left">
            <div class="pannel-1 border-radius-none">
              <div class="pannel-1-title">
                <h3>Bio</h3>
              </div>
              <div class="pannel-1-body">
                <p class="preline">{{ consultant.bio }}</p>
              </div>
            </div>
            <div
              class="pannel-1 border-radius-none relative"
              style="min-height: 150px"
              v-if="consultant.interview_url && type == 'allinfo'"
            >
              <div>
                <iframe
                  class="video-wrapper iframe-wrapper"
                  :src="consultant.interview_url"
                />
              </div>
            </div>

            <div class="pannel-1 border-radius-none">
              <div class="pannel-1-title">
                <h3>Certifications</h3>
              </div>
              <div class="pannel-1-body tech-cert-content">
                <ul
                  v-if="consultant.resume && consultant.resume.certifications"
                >
                  <li
                    v-for="(certification, index) in consultant.resume
                      .certifications"
                    :key="index"
                  >
                    <a
                      href="javascript:void(0)"
                      class="flex items-center"
                      @click="onClickCertification(index)"
                    >
                      <div
                        class="image"
                        :style="{
                          backgroundImage: `url(${certification.image_url}`,
                        }"
                      ></div>
                      <div
                        class="flex-1"
                        style="color: var(--font-color-lighter; font-weight: 800"
                      >
                        {{ certification.description }}
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="pannel-1 border-radius-none">
              <div class="pannel-1-title">
                <h3>Skills</h3>
              </div>
              <div class="pannel-1-body tech-cert-content">
                <ul
                  class="tech-skill-content"
                  v-if="consultant.resume && consultant.resume.skills"
                >
                  <li
                    v-for="(skill, index) in consultant.resume.skills"
                    :key="index"
                  >
                    <a href="javascript:void(0)">
                      {{ skill }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="pannel-1 border-radius-none">
              <div class="pannel-1-title">
                <h3>Tools</h3>
              </div>
              <div class="pannel-1-body tech-cert-content">
                <ul
                  class="tech-skill-content"
                  v-if="consultant.resume && consultant.resume.tools"
                >
                  <li
                    v-for="(tool, index) in consultant.resume.tools"
                    :key="index"
                  >
                    <a href="javascript:void(0)" @click="onClickTool(index)">{{
                      typeof tool === "string" ? tool : tool.name
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="main-flex-2">
            <div class="pannel-1 border-radius-none">
              <div class="pannel-1-title">
                <h3>Work History</h3>
              </div>
              <div class="hr m-t"></div>
              <div>
                <section
                  v-if="consultant.resume && consultant.resume.work_histories"
                >
                  <div
                    v-for="(workHistory, index) in consultant.resume
                      .work_histories"
                    :key="index"
                    class="work-history-experience work-history-item"
                    :style="{
                      background:
                        workHistory.displayIt === 'Yes'
                          ? 'lightgreen'
                          : workHistory.displayIt === 'No'
                          ? 'lightcoral'
                          : '#eee',
                    }"
                  >
                    <div class="flex justify-content-between">
                      <div class="work-history-info">
                        <h6 v-if="type == 'allinfo'">
                          {{ workHistory.company_name }}
                        </h6>
                        <h6 v-else>Company</h6>
                        <h5>{{ workHistory.job }}</h5>
                        <div>
                          <span
                            >{{
                              workHistory.start_time
                                | dateformatFilter("MMM YYYY")
                            }}
                            -
                            {{
                              workHistory.end_time
                                | dateformatFilter("MMM YYYY", true)
                            }}</span
                          >
                          <i class="material-icons align-middle">place</i>
                          {{ workHistory.location }}
                        </div>
                      </div>
                      <div
                        class="work-history-image"
                        :style="{
                          backgroundImage: `url(${workHistory.image_url}`,
                        }"
                        v-if="workHistory.image_url"
                      ></div>
                    </div>

                    <div class="flex-1">
                      <p
                        v-for="(experience, idx) in workHistory.experiences"
                        :key="idx"
                        class="preline"
                      >
                        {{ experience }}
                      </p>
                    </div>

                    <div class="ai-predict">
                      <div v-if="workHistory.displayIt">
                        IT:
                        {{
                          workHistory.displayIt === "NULL"
                            ? "Not enough info to judge"
                            : workHistory.displayIt
                        }}
                      </div>
                      <div
                        v-if="
                          workHistory.displayIt === 'Yes' &&
                          workHistory.displayType
                        "
                      >
                        Type:
                        {{ workHistory.displayType }}
                      </div>
                    </div>

                    <div class="hr m-t-2l" style="margin: 10px -20px 0"></div>
                  </div>
                </section>
              </div>
            </div>

            <div class="pannel-1 border-radius-none">
              <div class="pannel-1-title">
                <h3>Educations</h3>
              </div>
              <div class="hr m-t"></div>
              <div class="pannel-1-body">
                <section
                  v-if="consultant.resume && consultant.resume.educations"
                >
                  <div
                    v-for="(education, index) in consultant.resume.educations"
                    :key="index"
                    class="work-history-experience"
                  >
                    <div class="flex justify-content-between">
                      <div class="work-history-info">
                        <h6>
                          {{
                            type === "allinfo"
                              ? education.school_name
                              : "College"
                          }}
                        </h6>
                        <h5>{{ education.major }}</h5>
                        <div>
                          <span
                            >{{
                              education.start_time
                                | dateformatFilter("MMM YYYY")
                            }}
                            -
                            {{
                              education.end_time
                                | dateformatFilter("MMM YYYY", true)
                            }}</span
                          >
                          <i class="material-icons align-middle">place</i>
                          {{ education.location }}
                        </div>
                      </div>
                      <div
                        class="work-history-image"
                        :style="{
                          backgroundImage: `url(${education.image_url}`,
                        }"
                        v-if="education.image_url"
                      ></div>
                    </div>

                    <div class="flex-1">
                      <p
                        v-for="(experience, idx) in education.experiences"
                        :key="idx"
                        class="preline"
                      >
                        {{ experience }}
                      </p>
                    </div>

                    <div
                      class="hr m-t-2l"
                      style="margin-left: -20px; margin-right: -20px"
                    ></div>
                  </div>
                </section>
              </div>
            </div>

            <div
              class="pannel-1 border-radius-none"
              v-if="
                type === 'allinfo' &&
                consultant.resume &&
                consultant.resume.references &&
                consultant.resume.references.length > 0
              "
            >
              <div class="pannel-1-title">
                <h3>References</h3>
              </div>
              <div class="hr m-t"></div>
              <div class="pannel-1-body">
                <ul
                  class="blockquote"
                  v-if="consultant.resume && consultant.resume.references"
                >
                  <li
                    v-for="(reference, index) in consultant.resume.references"
                    :key="index"
                  >
                    <p>
                      {{ reference.content }}
                      <span>{{ reference.signature }}</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import * as utils from "@/utils/utils";

export default {
  data() {
    return {
      type: "anon",
      consultant: null,
      showRate: false,
    };
  },
  mounted: function () {
    this.getData();
  },
  watch: {
    consultant: function () {
      if (!this.consultant) return;
      if (!this.consultant.resume) {
        this.consultant.resume = {};
      }
      if (this.consultant.resume.work_histories) {
        this.consultant.resume.work_histories = utils.sortArray(
          this.consultant.resume.work_histories,
          "start_time"
        );
        this.consultant.resume.work_histories.forEach((item) => {
          if (item.yn_prediction_from_title) {
            item.displayIt =
              item.yn_prediction_from_title === "Y"
                ? "Yes"
                : item.yn_prediction_from_title === "N"
                ? "No"
                : "NULL";
          } else {
            item.displayIt = "NULL";
          }

          if (item.displayIt === "Yes") {
            if (
              item.tier_prediction_from_title &&
              item.tier_prediction_from_title !== "Not an IT person"
            ) {
              item.displayType = item.tier_prediction_from_title;
            } else if (
              item.tier_prediction_from_desc &&
              item.tier_prediction_from_desc !== "Not an IT person"
            ) {
              item.displayType = item.tier_prediction_from_desc;
            } else {
              item.displayType = "Tier 3 IT person";
            }
          }
        });
      }
      if (this.consultant.resume.educations)
        this.consultant.resume.educations = utils.sortArray(
          this.consultant.resume.educations,
          "start_time"
        );
    },
  },
  methods: {
    getData: function () {
      if (this.$route.query.rate) {
        this.showRate = this.$route.query.rate === "shown";
      }
      const id = this.$route.params.id;
      this.type = this.$route.params.type ? this.$route.params.type : "anon";
      if (id) {
        this.$bind("consultant", db.collection("consultants").doc(id));
      }
    },
    onClickCertification: function (index) {
      const link = this.consultant.resume.certifications[index].link;
      if (link) window.open(link, "_blank");
    },
    onClickTool: function (index) {
      if (typeof this.consultant.resume.tools[index] == "object") {
        const link = this.consultant.resume.tools[index].link;
        if (link) window.open(link, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.ai-predict {
  text-align: left;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 0.5rem;
}
.ai-predict > div {
  font-size: 1.5rem;
  font-weight: bold;
}
.flex-column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.flex-left {
  flex: 0 0 360px;
}
.iframe-wrapper {
  height: 180px;
}
.work-history-item {
  padding: 0 20px;
}
</style>
